
const AddIcon = () => {
    return (
        <svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="PP---Desktop---Chat-History---1920" transform="translate(-503, -54)">
                    <g id="Group-9" transform="translate(503, 54)">
                        <rect id="Rectangle-Copy-12" fill="#141718" x="0" y="0" width="22" height="22" rx="3"></rect>
                        <g id="Group-6" transform="translate(6, 6)" stroke="#FFFFFF" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                            <g id="Group-8">
                                <line x1="0" y1="5" x2="10" y2="5" id="Stroke-1"></line>
                                <line x1="5" y1="0" x2="5" y2="10" id="Stroke-3"></line>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default AddIcon;
